export default __webpack_public_path__ + "static/media/Vest of the Blood God.81a7b6da.jpg";